import React from 'react';

var _path;

var SvgHomeMajor = function SvgHomeMajor(props) {
  return (
    /*#__PURE__*/
    React.createElement("svg", Object.assign({
      viewBox: "0 0 20 20"
    }, props), _path || (_path =
    /*#__PURE__*/
    React.createElement("path", {
      d: "M18 7.261V17.5c0 .841-.672 1.5-1.5 1.5h-2c-.828 0-1.5-.659-1.5-1.5V13H7v4.477C7 18.318 6.328 19 5.5 19h-2c-.828 0-1.5-.682-1.5-1.523V7.261a1.5 1.5 0 0 1 .615-1.21l6.59-4.82a1.481 1.481 0 0 1 1.59 0l6.59 4.82A1.5 1.5 0 0 1 18 7.26z"
    })))
  );
};

export { SvgHomeMajor as S };